module.exports = __webpack_public_path__ + "img/gocce-vino.f1a42ef0.jpg";